import { PERMISSION } from "@app/modules/roles/constants";
import { DISABLED_WHEN_NO_ORDERS, DISABLED_WHEN_NO_PP, VerticalMenuItem } from "../entities";

export const VERTICAL_MENU_LIST: VerticalMenuItem[] = [
  {
    icon: "assets/icons/svg/edit-2.svg",
    text: "DASHBOARD.VERTICAL_MENU.MENU.NEW_ORDER",
    link: "create-order",
    permission: PERMISSION.ORDER_CREATE,
    disabledWhen: [DISABLED_WHEN_NO_PP],
  },
  {
    icon: "assets/icons/svg/invoice-paper.svg",
    text: "DASHBOARD.VERTICAL_MENU.MENU.ACTIVE_ORDERS",
    link: "active-orders",
    disabledWhen: [DISABLED_WHEN_NO_PP, DISABLED_WHEN_NO_ORDERS],
  },
  {
    icon: "assets/icons/svg/control-tower.svg",
    text: "DASHBOARD.VERTICAL_MENU.MENU.CONTROL_TOWER",
    link: "control-tower",
    highlight: true,
    disabledWhen: [DISABLED_WHEN_NO_PP, DISABLED_WHEN_NO_ORDERS],

    permission: PERMISSION.CONTROL_TOWER,
  },
  {
    icon: "assets/icons/svg/gps.svg",
    text: "DASHBOARD.VERTICAL_MENU.MENU.PICKUP_POINTS",
    link: "picking-points",
    permission: PERMISSION.PP_READ,
  },
  {
    icon: "assets/icons/svg/canvas-statistic.svg",
    text: "DASHBOARD.VERTICAL_MENU.MENU.REPORTS",
    disabledWhen: [DISABLED_WHEN_NO_PP, DISABLED_WHEN_NO_ORDERS],
    link: "reports",
    permission: PERMISSION.REPORTS,
  },
  {
    icon: "assets/icons/svg/law.svg",
    text: "DASHBOARD.VERTICAL_MENU.MENU.BILLING_SETTLEMENT",
    disabledWhen: [DISABLED_WHEN_NO_PP, DISABLED_WHEN_NO_ORDERS],
    permission: PERMISSION.MANAGE_SETTLEMENT,
    subsections: [
      {
        text: "DASHBOARD.VERTICAL_MENU.MENU.SETTLEMENT",
        link: "settlement",
        permission: PERMISSION.MANAGE_SETTLEMENT,
      },
      {
        text: "DASHBOARD.VERTICAL_MENU.MENU.BILLING",
        link: "settlement/billing",
        cashlessOnly: true,
        permission: PERMISSION.MANAGE_SETTLEMENT,
      },
      {
        text: "DASHBOARD.VERTICAL_MENU.MENU.SALES_SUMMARY",
        link: "settlement/sales-summary",
        permission: PERMISSION.MANAGE_SETTLEMENT,
      },
      {
        // Sin `cashlessOnly`: esa bandera marca al aliado que usa cargo-cashless, así que escondería
        // esta pantalla justo de los aliados que sí cobran en efectivo.
        text: "DASHBOARD.VERTICAL_MENU.MENU.CASH_PAYOUTS",
        link: "settlement/cash-payouts",
        permission: PERMISSION.MANAGE_SETTLEMENT,
      },
    ],
  },
  {
    icon: "assets/icons/svg/extension.svg",
    text: "DASHBOARD.VERTICAL_MENU.MENU.DEVPORTAL",
    link: "dev-portal",
    permission: PERMISSION.DEV_PORTAL,
  },
  {
    icon: "assets/icons/svg/user-circle.svg",
    text: "DASHBOARD.VERTICAL_MENU.MENU.TEAM",
    permissions: [PERMISSION.LIST_USERS, PERMISSION.HANDLE_ROLES],
    subsections: [
      {
        text: "DASHBOARD.VERTICAL_MENU.MENU.USERS",
        link: "team/users",
        permission: PERMISSION.LIST_USERS,
      },
      {
        text: "DASHBOARD.VERTICAL_MENU.MENU.ROLES",
        link: "team/roles",
        permission: PERMISSION.HANDLE_ROLES,
      },
    ],
  },
  {
    icon: "assets/icons/svg/settings.svg",
    text: "DASHBOARD.VERTICAL_MENU.MENU.SETTINGS",
    subsections: [
      {
        text: "DASHBOARD.VERTICAL_MENU.MENU.TIP_SETTINGS",
        link: "settings/tips",
        permissions: [PERMISSION.PP_UPDATE_WITH_INCENTIVE_SETTINGS, PERMISSION.RETAILER_UPDATE_WITH_INCENTIVE_SETTINGS],
      },
      {
        text: "DASHBOARD.VERTICAL_MENU.MENU.COMPANY_SETTINGS",
        link: "settings/company",
        permission: PERMISSION.RETAILER_UPDATE,
      },
      {
        text: "DASHBOARD.VERTICAL_MENU.MENU.TWOFACTOR_SETTINGS",
        link: "security",
      },
    ],
  },
];

export const ONBOARDING_DATA_LS = "__retailer_onboarding_success__";
